import get from 'lodash/get'
import BaseImageImporter from './BaseImageImporter'

export default class VolkswagenImageImporter extends BaseImageImporter {
  constructor() {
    super('volkswagen')

    this.blacklistedImagePatterns = [
      /ColorTile$/i,
      /RimTile$/i,
      /InteriorTile$/i,
      /Print/i
    ]
  }

  import(configuration) {
    return get(configuration, 'consolidatedData.mediaAssets', [])
      .filter(({ asset }) => asset !== null)
      .map(media => this.mapMedia(media))
      .filter(media => !this.isBlacklisted(media))
  }

  mapMedia(media) {
    return {
      origin: this.id,
      url: media.asset,
      name: media.mpsId,
      mime: 'image/jpeg'
    }
  }

  isBlacklisted(media) {
    return this.blacklistedImagePatterns.some(pattern => pattern.test(media.name))
  }
}
